"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _helper = require("../../utils/helper");
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _BrixelButtonSecondary = _interopRequireDefault(require("../BrixelButtonSecondary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelTextArea = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    buttonLabel,
    className = '',
    disabled = false,
    input,
    isSmall = false,
    label = null,
    large = false,
    message = {
      help: ''
    },
    meta = {
      dirty: false,
      invalid: false
    },
    modal = null,
    noTranslate = false,
    placeholder = '',
    showCountCharacters = false,
    showError = false,
    tooltip,
    validation = false
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value || '');
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const [numCharacters, setNumCharacters] = (0, _react.useState)(0);
  const textarea = (0, _react.useRef)(null);
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, 500);
  const onChange = e => {
    let value = (0, _helper.sanitizeText)(e);
    if (typeof e === 'string') {
      value = e;
    } else {
      e.preventDefault();
      value = (0, _get.default)(e, 'target.value', '');
    }
    if (typeof value === 'string') setCurrentValue(value);
  };
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue) {
      input.onChange(currentValue);
      setNumCharacters(currentValue.length);
    }
  }, [debouncedSearchTerm]);
  const onBlur = e => {
    if (input.onChange && input.value !== currentValue) {
      input.onChange(currentValue);
    }
    if (input.onBlur) input.onBlur(e);
  };
  const onFocus = e => {
    if (input.onFocus) input.onFocus(e);
  };
  (0, _react.useEffect)(() => {
    setCurrentValue(input.value || '');
    if (input.value) setNumCharacters(input.value.length);
  }, [input.value]);
  // FUNCTION TO AUTOGROW TEXTAREA
  (0, _react.useEffect)(() => {
    const getScrollEl = document.getElementById('root');
    if (getScrollEl) {
      let text = textarea.current;
      if ((0, _get.default)(ref, 'current', null)) text = (0, _get.default)(ref, 'current', null);
      const scrollLeft = getScrollEl.scrollLeft || (document.documentElement || document.body.parentNode || document.body).scrollLeft;
      const scrollTop = getScrollEl.scrollTop || (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if (text) {
        text.style.height = 'auto';
        text.style.height = `${text.scrollHeight + 2}px`;
      }
      if (typeof getScrollEl.scrollTo === 'function') {
        getScrollEl.scrollTo(scrollLeft, scrollTop);
      }
    }
  }, [currentValue]);
  // scroll focused input to avoid overlap with save bar
  (0, _react.useEffect)(() => {
    if (isFocused) {
      const inputEl = document.activeElement;
      if (inputEl) {
        const isInputFocused = inputEl.tagName.toString().toLowerCase() === 'input';
        const bodyScrollFunc = (0, _helper.bodyScrollclassFunc)();
        if (bodyScrollFunc) {
          const parentRect = bodyScrollFunc.getBoundingClientRect();
          const parentTop = parentRect.top;
          const rect = inputEl.getBoundingClientRect();
          const skeltonHeight = rect.bottom - parentTop;
          const avilableHeight = bodyScrollFunc.clientHeight;
          const heightDiff = avilableHeight - skeltonHeight;
          const toScroll = () => {
            let finalNumb;
            const barHeight = 80;
            if (Math.sign(heightDiff) === -1) {
              finalNumb = barHeight + Math.abs(heightDiff);
            } else {
              finalNumb = barHeight - Math.abs(heightDiff);
            }
            return finalNumb;
          };
          let scrollToCord;
          if (bodyScrollFunc) scrollToCord = bodyScrollFunc.scrollTop + toScroll();
          if (scrollToCord && isInputFocused && heightDiff < 80 && bodyScrollFunc.scrollTo) {
            bodyScrollFunc.scrollTo({
              top: scrollToCord,
              behavior: 'smooth'
            });
          }
        } else if (inputEl && typeof window !== 'undefined') {
          const rect = inputEl.getBoundingClientRect();
          const skeltonHeight = rect.bottom;
          const avilableHeight = window.innerHeight;
          const heightDiff = avilableHeight - skeltonHeight;
          const toScroll = () => {
            let finalNumb;
            const barHeight = 80;
            if (Math.sign(heightDiff) === -1) {
              finalNumb = barHeight + Math.abs(heightDiff);
            } else {
              finalNumb = barHeight - Math.abs(heightDiff);
            }
            return finalNumb;
          };
          let scrollToCord;
          if (typeof document !== 'undefined' && document.scrollingElement) scrollToCord = document.scrollingElement.scrollTop + toScroll();
          if (scrollToCord && isInputFocused && heightDiff < 80) {
            window.scrollTo({
              top: scrollToCord,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  }, [isFocused]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-f a-c ${buttonLabel ? 'jc-b mb-1' : ''}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `brixel-label ${large ? 'labelLarge' : ''} ${buttonLabel ? 'mb-0' : ''}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), buttonLabel && (/*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
    ...buttonLabel,
    rounded: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-fl-col brixel-text-area-container ${meta.dirty && meta.invalid ? 'error' : ''}`
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    "data-validation": validation,
    // @ts-ignore
    ref: ref || textarea,
    className: `brixel-text-area ${large ? 'large' : ''} ${disabled ? 'disabled' : ''} notranslate`,
    // defaultValue={input.value}
    onBlur: e => {
      onBlur(e);
      setIsFocused(false);
    },
    onFocus: e => {
      onFocus(e);
      setIsFocused(true);
    },
    // defaultValue={currentValue}
    value: currentValue,
    placeholder: placeholder,
    rows: isSmall ? 1 : 0,
    disabled: disabled,
    name: input.name,
    onChange: e => onChange(e)
  }), showCountCharacters && (/*#__PURE__*/_react.default.createElement("small", {
    className: "countCharactersEditor dis-b ta-r mt-1"
  }, numCharacters)), placeholder && !noTranslate && (/*#__PURE__*/_react.default.createElement("span", {
    className: "hiddentext"
  }, placeholder)), ((0, _get.default)(message, 'help', null) || (0, _get.default)(meta, 'invalid', null) && showError) && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${(0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) ? 'error-message' : ''}`
  }, (0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) && showError ? (0, _get.default)(message, 'error', '') : (0, _get.default)(message, 'help', ''))), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  }))));
});
BrixelTextArea.displayName = 'BrixelTextArea';
var _default = exports.default = BrixelTextArea;